import React, { useState, useEffect } from 'react';
var Checkbox = function (props) {
    var id = props.id, isValid = props.isValid, disabled = props.disabled, required = props.required, checked = props.checked, children = props.children, onChange = props.onChange;
    var _a = useState(!!(checked && checked !== 'false')), isChecked = _a[0], setIsChecked = _a[1];
    useEffect(function () { return setIsChecked(!!(checked && checked !== 'false')); }, [checked]);
    var handleOnChange = function (nativeEvent) {
        var isChecked = nativeEvent.target.checked;
        setIsChecked(isChecked);
        nativeEvent.target.value = isChecked ? 'true' : 'false';
        return onChange && onChange(nativeEvent);
    };
    return (React.createElement("div", { className: "custom-control custom-checkbox" },
        React.createElement("input", { autoComplete: "off", checked: isChecked, className: "custom-control-input" + (isValid ? '' : ' is-invalid'), disabled: disabled, id: id, required: required, type: "checkbox", onChange: handleOnChange }),
        React.createElement("label", { className: "custom-control-label", htmlFor: id }, children)));
};
export default Checkbox;
